import { useNavigate, useLocation } from "react-router-dom";
import useChatStore from "../utils/chatStore"; // Import chatStore
import useExerciseChatStore from "./exerciseChatStore";
import { useQuestionsStore } from "./questionStore";
import { RouterConstant } from "../routers/index";
import { useUserStore } from "./userStore";
import useAudioStore from "./audioStore";
import { useExerciseStore } from "./exerciseStore";
import { useAdminUserStore } from "./adminUserStore";
import { usePillsStore } from "./pillsStore";
import { gamificationStore } from "./gamificationStore";
import { useLessonPlayerStore } from "./lessonPlayerStore";
import { useTeacherStore } from "./teacherStore";
import { LoginService } from "../services/login/login.services";

const { ROUTERS_PATH } = RouterConstant;
const loginService = new LoginService();


export const clientSideLogout = (): void => {
  try {
    useQuestionsStore.getState().clearCompletedQuestions();
    useQuestionsStore.getState().clearCurrentQuestions();
    useQuestionsStore.getState().clearSteps();
    useQuestionsStore.getState().clearQuestionHistory();
    useChatStore.getState().clearMessages();
    useExerciseChatStore.getState().clearMessages();
    useAudioStore.getState().clearAudioCache();
    useUserStore.getState().resetUser();
    useTeacherStore.getState().resetTeacherStore();
    useExerciseStore.getState().clearCaptureImageSessionId();
    useExerciseStore.getState().resetParams();
    useExerciseStore.getState().setSelectedExerciseId(0);
    useAdminUserStore.getState().clearExerciseData();
    usePillsStore.getState().resetPills();
    gamificationStore.getState().resetState();
    useLessonPlayerStore.getState().resetStore();
    // resetUser() on line 26 also clears isLoggedIn (Zustand persisted state)
  } catch (error) {
    console.log("Error while clearing client stores:", error);
  }
};

export const logout = async (navigate?: (path: string) => void): Promise<void> => {
  try {
    // 1. Navigate to the public root FIRST to stop security guards from triggering
    if (navigate) {
      navigate(ROUTERS_PATH.ROOT_PATH);
    } else {
      window.location.replace(ROUTERS_PATH.ROOT_PATH);
    }

    // 2. Perform all local cleanup (resets store, clears isLoggedIn from localStorage)
    clientSideLogout();

    // 3. Inform server (non-blocking)
    await loginService.handleServerLogout();
  } catch (error) {
    console.error("Error during logout:", error);
    window.location.replace(ROUTERS_PATH.ROOT_PATH);
  }
};